import { computed, ref, type Ref } from 'vue';
import { type Address } from '@models/address.ts';

export const useStreetDistrict = (addressValue: Address | Ref<Address>) => {
  const address: Ref<Address> = ref(addressValue);

  const capitalizeFirstLetter = (str: string): string => str.charAt(0).toUpperCase() + str.substring(1);

  const formattedAddress = computed<string>(() => {
    if (!address.value.street) {
      return `${address.value.city}, ${address.value.zip_code}`;
    }

    return `${address.value.street.trim()}, ${address.value.city}`;
  });

  const cityDistrict = computed<number | null>(() => {
    const match = address.value.zip_code.match(/^(?:75[0-1]|130|690)?(\d{1,2})$/);

    if (!match) {
      return null;
    }

    return parseInt(match[1], 10);
  });

  const formattedStreetDistrict = computed<string>(() => {
    const capitalizedStreetDistrict = capitalizeFirstLetter(formattedAddress.value);

    return cityDistrict.value ? `${capitalizedStreetDistrict} ${cityDistrict.value}` : capitalizedStreetDistrict;
  });

  return {
    formattedAddress,
    cityDistrict,
    formattedStreetDistrict,
  };
};
